const fieldNames = Object.freeze({
  taxAuthority: 'taxAuthority',
  yearf: 'yearf',
  bank: 'bank',
  reasonNameNum: {
    name: 'reasonNameNum',
    label: 'Вид проблемы',
    items: [
      { label: 'У меня нет вклада в этом банке', value: '1' },
      { label: 'Неверно указана сумма дохода', value: '2' },
      { label: 'Неверно указан период получения дохода', value: '3' },
    ],
    isRequired: true,
  },
});

export default fieldNames;
